import { Suspense, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { LoadingSpinner } from "../../../../../../router/LoadingSpinner";
import { lazyWithRetry } from "../../../../../../utils/lazyWithRetry";
import Tabs from "./Tabs";

const Earnings = lazyWithRetry(() => import("./Earnings"));
const Dividends = lazyWithRetry(() => import("./Dividends"));

export type EarningsSubView = "earnings" | "dividends";

type EarningsTabProps = {
  earningsView: EarningsSubView;
  onEarningsViewChange: (view: EarningsSubView) => void;
};

export default function EarningsTab({
  earningsView,
  onEarningsViewChange,
}: EarningsTabProps) {
  const { t } = useTranslation();

  const items = useMemo(
    () => [
      {
        key: "earnings",
        label: t("pages.stock.tabs.earnings"),
        children: (
          <Suspense fallback={<LoadingSpinner />}>
            <Earnings />
          </Suspense>
        ),
      },
      {
        key: "dividends",
        label: t("pages.stock.tabs.dividends"),
        children: (
          <Suspense fallback={<LoadingSpinner />}>
            <Dividends />
          </Suspense>
        ),
      },
    ],
    [t],
  );

  return (
    <Tabs
      activeKey={earningsView}
      items={items}
      onChange={(key) => onEarningsViewChange(key as EarningsSubView)}
      destroyOnHidden
    />
  );
}
